import { Button } from 'antd'

const MobileButton = ({
    width = '100%',
    bg = '#7C9BAD',
    color = 'white',
    children,
    onClick = () => {},
    margin = '0'
}) => {
    return (
        <Button
            onClick={onClick}
            style={{
                margin: margin,
                borderRadius: 12,
                width: width,
                paddingTop: 0,
                paddingBottom: 0,
                height: 50,
                backgroundColor: bg,
                border: 'none',
                fontSize: 17,
                color: color
            }}
        >
            {children}
        </Button>
    )
}

export default MobileButton
